import React from 'react';
import { testimonials } from '../data/matikka';
export function Testimonials() {
  // Hidden until authentic YMPÄRISTÖOPPI VALMIS reviews are added in data/ymparistooppi.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-283" data-mp="3fycpzlihi3a9">
      <div className="mx-auto max-w-6xl" data-id="element-284" data-mp="3b01hbe3xdytm">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-285" data-mp="36yzhav26piql">
          Mitä <em className="text-red-700" data-id="element-286" data-mp="32063t2mwdrqf">opettajat</em> sanovat
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-287" data-mp="3229187qdqn56">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-288" data-mp="2s1yn8kwitboy">
              <div className="text-sm text-amber-500" aria-label="5 / 5 tähteä" data-id="element-289" data-mp="2s3tba8339jx9">
                <span aria-hidden="true" data-id="element-290" data-mp="v8ndhf596tkq">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-291" data-mp="qbesz7wmudgb">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-292" data-mp="m51dby0rthb2">
                <span className="font-semibold text-slate-900" data-id="element-293" data-mp="m5swuah3fokz">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-294" data-mp="78k53fnvoisq"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}